/**
 *  AenaPmr script file
**/

import { GETTERS, ACTIONS, MUTATIONS } from '@/store'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'
import { toggleFocus } from '@/utils/toggleFocus'

export default {
  name: 'AenaPmr',
  mixins: [setDeviceWidthClass],
  components: {},
  props: {},
  data () {
    return {
      escalatorActive: true,
      rampsActive: false,
      language: this.$i18n.locale
    }
  },
  computed: {
    ...mapGetters({
      pmrConfigVisible: GETTERS.PMR_CONFIG_VISIBLE,
      pmrProfile: GETTERS.GET_PMR_PROFILE,
      pmrDefaultProfile: GETTERS.GET_DEFAULT_PMR_PROFILE
    }),
    pmrActive () {
      if (this.pmrProfile === this.pmrDefaultProfile) {
        this.setDefaultPMROptions()
      }
      return this.pmrProfile !== null
    }
  },
  methods: {
    ...mapActions([
      ACTIONS.SET_PMR_PROFILE
    ]),
    ...mapMutations([
      MUTATIONS.SAVE_PMR_CONFIG_VISIBILITY
    ]),
    getProfile () {
      if (this.escalatorActive && this.rampsActive) {
        return 'pmr_4'
      } else if (this.escalatorActive) {
        return 'pmr_3'
      } else if (this.rampsActive) {
        return 'pmr_2'
      }
      return 'pmr_1'
    },
    setPMROption (key, value) {
      this[key] = value
      this[ACTIONS.SET_PMR_PROFILE](this.getProfile())
    },
    toggle (state) {
      this[MUTATIONS.SAVE_PMR_CONFIG_VISIBILITY](!this.pmrConfigVisible)

      const parent = document.querySelector('.flughaveno-map')
      if (this.pmrConfigVisible && state !== 'close') {
        window.setTimeout(() => {
          const dialog = this.$refs.popup
          toggleFocus('pmr-wrapper', parent, true)
          dialog.focus()
        }, 300)
      } else {
        toggleFocus('pmr-wrapper', parent, false)
        document.removeEventListener('keydown', this.toggle)
      }
    },
    togglePMR () {
      this.setDefaultPMROptions()
      this[ACTIONS.SET_PMR_PROFILE](this.pmrProfile ? null : this.getProfile())
    },
    setDefaultPMROptions () {
      this.escalatorActive = false
      this.rampsActive = false
    }
  }
}
